export const TypedCouponsDays = {
  MON: "MON",
  TUES: "TUES",
  WED: "WED",
  THURS: "THURS",
  FRaI: "FRI",
  SAT: "SAT",
  SUN: "SUN",
};
